var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagAr = function SvgFlagAr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-ar_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-ar_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-ar_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.857 0H-.857C-2.593 0-4 1.433-4 3.2v17.6C-4 22.567-2.593 24-.857 24h26.714C27.593 24 29 22.567 29 20.8V3.2C29 1.433 27.593 0 25.857 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    fillRule: "evenodd",
    d: "M-4 16.5h33V24H-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#249F58",
    fillRule: "evenodd",
    d: "M-4 0h33v7.5H-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    fillRule: "evenodd",
    d: "M-4 0v24h9V0z",
    clipRule: "evenodd"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-ar_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-ar_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-4 0h33v24H-4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-ar_svg__c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 24,
    x: -4,
    fill: "#fff",
    rx: 3
  })))));
};
export default SvgFlagAr;